import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "@/data/site";

export const MobileCallBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-[#0F2840]/10 bg-white/95 backdrop-blur md:hidden" data-testid="mobile-call-bar">
    <a href={COMPANY.telephoneHref} data-testid="mobile-call-btn" className="flex items-center justify-center gap-2 py-3.5 text-sm font-bold text-[#0F2840]">
      <Phone className="h-4 w-4" /> Appeler
    </a>
    <Link to="/devis" data-testid="mobile-devis-btn" className="flex items-center justify-center gap-2 bg-[#D82C2C] py-3.5 text-sm font-bold text-white">
      <FileText className="h-4 w-4" /> Devis gratuit
    </Link>
  </div>
);
